import { KeyboardEvent, ReactNode, useState } from 'react';
import { Input } from '@design-system/components/input/input';
import { Chips } from './Chips';
import * as styles from './EquipmentField.css';

export type EquipmentFieldProps = {
  value: string[];
  onChange: (next: string[]) => void;
  maxItems: number;
  maxLength: number;
  disabled?: boolean;
  placeholder?: string;
  hint?: ReactNode;
  testId?: string;
};

const stripDisallowedChars = (raw: string) =>
  raw.replace(/[^0-9a-zA-Z\s]+/g, '');

export const EquipmentField = ({
  value,
  onChange,
  maxItems,
  maxLength,
  disabled,
  placeholder = 'Write',
  hint,
  testId,
}: EquipmentFieldProps) => {
  const [draft, setDraft] = useState('');
  const isFull = value.length >= maxItems;

  const add = () => {
    const next = draft.trim();
    if (!next) return;
    if (value.some((t) => t.toLowerCase() === next.toLowerCase())) return;
    onChange([...value, next]);
    setDraft('');
  };

  const remove = (tag: string) => onChange(value.filter((t) => t !== tag));

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      add();
    }
  };

  return (
    <div className={styles.wrapper} data-testid={testId}>
      {isFull ? null : (
        <Input
          value={draft}
          onChange={(e) => setDraft(stripDisallowedChars(e.target.value))}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
        />
      )}
      {hint}
      <Chips values={value} onRemove={remove} disabled={disabled} />
    </div>
  );
};
